import { useQuery } from '@tanstack/react-query'
import { api } from '@personic/shared'
import type { ProfileDetail } from './useAdminProfiles'

export function useMyProfile() {
  return useQuery<ProfileDetail>({
    queryKey: ['my-profile'],
    queryFn: async () => {
      const res = await api.get('/admin/mindmetal/my-profile')
      return res.data
    },
    retry: false,
  })
}
